/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfInteger } from '../../models/platform-api-result-of-integer';

export interface PostFeedbackMineActionMarkAllSeen$Params {
}

export function postFeedbackMineActionMarkAllSeen(http: HttpClient, rootUrl: string, params?: PostFeedbackMineActionMarkAllSeen$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfInteger>> {
  const rb = new RequestBuilder(rootUrl, postFeedbackMineActionMarkAllSeen.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfInteger>;
    })
  );
}

postFeedbackMineActionMarkAllSeen.PATH = '/api/feedback/mine/action/mark-all-seen';
